import React from 'react'
import { Redirect, RouteComponentProps, withRouter } from 'react-router-dom'
import { MsalAuthenticationTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import { InteractionType } from '@azure/msal-browser'

import staticData from "../../config/staticData"
import { activateUserRequest } from '../../config/msalConfig'
import { msalInstance } from '../../msalClient'

type PathParamsType = {
  idTokenHint: string
}

type ActivateAccountType = RouteComponentProps<PathParamsType>

const activateAccount = (props: ActivateAccountType) => {
  // If user is logged in, then redirect to root of app
  const activeAccount = msalInstance.getActiveAccount()
  if (activeAccount) {
    return (<Redirect to="/" />)
  }

  sessionStorage.setItem('adb2c_access_token_policy', 'B2C_1A_PARTNER_SIGNUPINVITATION')

  const queryParamsString = props.location.search.substring(1)
  const searchParams = new URLSearchParams(queryParamsString)
  const idTokenHint = searchParams.get('idTokenHint') ?? ''

  const redirectUri = `${window.location.protocol}//${window.location.host}${staticData.basePath}`

  return (
    <UnauthenticatedTemplate>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={{
          ...activateUserRequest(redirectUri, idTokenHint),
        }}
      />
    </UnauthenticatedTemplate>
  )
}

export default withRouter(activateAccount)
